import * as React from 'react'
import {
  FooterArea,
  GridContainer,
  GridItem,
  Link,
  GridSeparator,
  PhoneIcon,
  HelpIcon,
  LinkContainer,
  NumberLink,
  CustomPhoneIcon
} from './PrivateFooter.styles'
import {
  REACT_APP_TERMS_AND_CONDITIONS_URL,
  REACT_APP_CENTROAYUDA_BASE_URL,
  REACT_APP_FIRTS_NUMBER,
  REACT_APP_SECOND_PRIVATE_NUMBER,
  PUBLIC_URL
} from '../../config/settings/environment'
import { Typography } from '@chilecompra/react-kit/components'
import { useViewport } from '@chilecompra/react-kit'

/**
 * The Private Footer container.
 */
const PrivateFooterContainer = () => {
  const {
    size: { isDownToLarge }
  } = useViewport()

  return (
    <FooterArea position="fixed">
      <GridContainer>
        <GridSeparator xs={12} />
        <GridItem lg={6} md={6} xs={12}>
          <GridContainer>
            <GridItem xs={12}>
              <Typography fontSize="14px" color="black1" padding={isDownToLarge ? '45px 0 0' : 0} variant="body2">
                Dirección de Compras y Contratación Pública ChileCompra
              </Typography>
            </GridItem>
            <GridItem xs={12}>
              <Typography color="white" variant="body2" fontSize="14px" margin="8px 0">
                <Link target="_blank" rel="noreferrer" href={REACT_APP_TERMS_AND_CONDITIONS_URL}>
                  Términos y condiciones de uso
                </Link>
              </Typography>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem lg={6} md={6} xs={12}>
          <LinkContainer>
            <GridItem lg={5} xs={12} container justifyContent="end" padding={isDownToLarge ? '15px 0 10px' : '0'}>
              <PhoneIcon />
              <Typography
                color="black2"
                fontSize="14px"
                variant="body2"
                margin="2px 0 0 8px"
                padding={isDownToLarge ? '0' : '0 5px 0 0'}
              >
                <NumberLink href={`tel:+${REACT_APP_FIRTS_NUMBER}`}> 600 0061 211 </NumberLink>
              </Typography>
            </GridItem>
            <GridItem
              lg={3}
              xs={12}
              container
              justifyContent="end"
              padding={isDownToLarge ? '10px 0 10px' : '0 5px 0 0'}
            >
              <CustomPhoneIcon src={`${PUBLIC_URL}/assets/images/phone_icon.svg`} alt="Phone icon" />
              <Typography
                color="black2"
                fontSize="14px"
                variant="body2"
                margin="2px 0 0 8px"
                padding={isDownToLarge ? '0' : '0 5px 0 0'}
              >
                <NumberLink href={`tel:+${REACT_APP_SECOND_PRIVATE_NUMBER}`}> +56 2 2595 0820 </NumberLink>
              </Typography>
            </GridItem>
            <GridItem
              lg={3}
              xs={12}
              container
              justifyContent="end"
              padding={isDownToLarge ? '10px 0 10px' : '0 5px 0 0'}
            >
              <HelpIcon />
              <Typography
                color="white"
                fontSize="14px"
                variant="body2"
                margin="1px 0 0 8px"
                padding={isDownToLarge ? '0' : '0 5px 0 0'}
              >
                <Link target="_blank" rel="noreferrer" href={REACT_APP_CENTROAYUDA_BASE_URL}>
                  Centro de Ayuda
                </Link>
              </Typography>
            </GridItem>
            <GridItem lg={1} xs={12} container justifyContent="end" padding={isDownToLarge ? '10px 0 10px' : '0'}>
              <Typography color="black2" fontSize="14px" variant="body2" padd>
                (4 N)
              </Typography>
            </GridItem>
          </LinkContainer>
        </GridItem>
      </GridContainer>
    </FooterArea>
  )
}

export default PrivateFooterContainer
